export default "__VITE_ASSET__BK$6xTBb__"